import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContactStore } from 'app/core/stores/base.store';
import { NotificationUtils } from 'app/core/utils';

@Component({
  selector: 'app-insurance-contact-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './insurance-contact-dialog.component.html',
  styleUrls: ['./insurance-contact-dialog.component.css']
})
export class InsuranceContactDialogComponent {
  contactForm: FormGroup;
  
  private contactStore = inject(ContactStore);
  
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<InsuranceContactDialogComponent>
  ) {
    this.contactForm = this.fb.group({
      user_id: [JSON.parse(localStorage.getItem('user_profile')).id],
      category: ['Insurance'], // Fixed as 'Insurance'
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      organization: [''],
    });
  }
  
  onSubmit() {
    if (this.contactForm.valid) {
      const formValue = this.contactForm.value;
      
      // Create the insurance contact
      this.contactStore.create({
        entity: formValue,
        endpoint: 'contact'
      });
      this.dialogRef.close();
    }
  }
  
  cancel() {
    this.dialogRef.close();
  }
}
